export const COOKIES_ACTIVATED = 'cookiesActivated';